import React, {useEffect} from "react";

import styles from "./TranscriptsTab.module.css"
import {TranscriptTable} from "../TranscriptTable";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {MenuItem, updateSelectedMenuItem} from "../../../platform/platformSlice";
import {
    fetchBotOptions,
    transcriptTableBotOptionsSelector,
    transcriptTableBotOptionsRequestStatusSelector,
    transcriptTableRequestSelector,
    updateTranscriptTableRequest
} from "../../transcriptListSlice";
import {
    MultiSelectTableFilterDropdown
} from "../../../../elements/multiSelectTableFilter/MultiSelectTableFilterDropdown";
import {useRequestErrorToast} from "../../../../../hooks/useRequestErrorToast";

export const TranscriptsTab: React.FC = () => {

    const dispatch = useAppDispatch()

    const transcriptTableRequest = useAppSelector(transcriptTableRequestSelector)
    const botOptions = useAppSelector(transcriptTableBotOptionsSelector)

    useRequestErrorToast(useAppSelector(transcriptTableBotOptionsRequestStatusSelector),
        "Failed to load the assistant filter")


    useEffect(() => {
        dispatch(fetchBotOptions())
        dispatch(updateSelectedMenuItem(MenuItem.TRANSCRIPTS))
    }, [dispatch]);

    return <div className={styles.wrapper}>
        <div className={styles.headerSectionWrapper}>
            <span className={styles.title}>Transcripts</span>
            {botOptions.length > 1 && <MultiSelectTableFilterDropdown<string, {}>
                value={transcriptTableRequest.publicBotIdList}
                placeholder={"Filter by Assistant"}
                width={220}
                handleChange={(publicBotIds) => dispatch(updateTranscriptTableRequest({publicBotIdList: publicBotIds}))}
                options={botOptions}
            />}
        </div>
        <TranscriptTable/>
    </div>
}
